import React, { Component } from 'react'
import style from './style.module.less'
import auth, { CONTACT_US } from '../auth'

/** 联系我们 */
@auth(CONTACT_US)
export default class extends Component {
  render() {
    return (
      <div className={style.contactUs}>
        <p className={style.title}>
          <span style={{ fontSize: 16 }}>联系我们</span>
          <span style={{ fontSize: 12, color: '#999', marginLeft: 12 }}>
            工作日 9:00-12:00 13:00-18:00
          </span>
        </p>
        <div className={style.main}>
          <div className={style.text}>功能使用有疑问、评价申诉、侵权投诉</div>
          <div className={style.phone}>电话：400-159-9090</div>
        </div>
      </div>
    )
  }
}
